module.exports = __webpack_public_path__ + "static/media/atomizador_rotativo_disco.a0ebf03a.png";